import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Card } from 'primereact/card';

const ViewMemberBeneficiaries = ({ activeUserData }) => {
  const Users = activeUserData;

  const colsOtherMember1 = [
    { field: 'BenTitle', header: 'Title' },
    { field: 'BenName', header: 'First name' },
    { field: 'BenSurname', header: 'Last name' },
    { field: 'BenDOB', header: 'Date Of Birth' },
    { field: 'BenID', header: 'ID number' },
    { field: 'BenRelation', header: 'Relationship' },
    { field: 'BenTelephone', header: 'Phone' },
    { field: 'BenGender', header: 'Gender' },
  ];

//   const colsMainMember2 = [
//     { field: 'Gender', header: 'Gender' },
//     { field: 'Marital_Status', header: 'Marital Status' },
//     { field: 'Date_Of_Birth', header: 'Date Of Birth' },
//     { field: 'Region', header: 'Nationality' },
//     { field: 'EmailAddress', header: 'Email' },
//     { field: 'Address', header: 'Physical and Postal Address' }
//   ];

  return (
    <div className="card home-chart">
        <Card>
        <center><h2 className="card-title home-chart">MORE BENEFICIARY DETAILS</h2></center>


        <div className="card-body">
            <DataTable
            value={[Users.memberBeneficiary]}
            tableStyle={{ minWidth: '50rem' }}
            emptyMessage="No Users found"
            >
            {colsOtherMember1.map((col, index) => (
                <Column key={index} field={col.field} header={col.header} />
            ))}
            </DataTable>

            <br />

            {/* <DataTable
            value={[Users.memberBeneficiary]}
            tableStyle={{ minWidth: '50rem' }}
            emptyMessage="No Users found"
            >
            {colsMainMember2.map((col, index) => (
                <Column key={index} field={col.field} header={col.header} />
            ))}
            </DataTable> */}
        </div>
        </Card>
    </div>
  );
};

export default ViewMemberBeneficiaries;
